// Admin\src\components\send_notification\SendNotification.js

import React, { useState } from 'react';
import { toaster } from '../../apis/commonFunctions';
import { postRequest } from '../../apis/functions';
import APIS from '../../apis/routes';
import Button from '../../common/Button'; // Assuming you have a custom Button component

export default function SendNotification() {
    const [title, setTitle] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const maxMessageLength = 120;

    const handleSendNotification = async (e) => {
        e.preventDefault(); // Prevent default form submission if wrapped in a form

        if (!title.trim()) {
            toaster('Notification title cannot be empty.', false);
            return;
        }
        if (!message.trim()) {
            toaster('Notification message cannot be empty.', false);
            return;
        }

        setLoading(true);
        try {
            const payload = { title, message };
            const result = await postRequest(APIS.SEND_NOTIFICATION_TO_ALL, payload);

            if (result.data && result.data.status) {
                toaster(result.data.message || 'Notification sent successfully!', true);
                // Clear fields after successful sending
                setTitle('');
                setMessage('');
            } else {
                // Handle backend-specific error messages
                toaster(result.data.message || 'Failed to send notification.', false);
            }
        } catch (err) {
            console.error("Error sending notification:", err);
            toaster(err.message || 'An error occurred while sending the notification.', false);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {/* Page Title */}
            <div className="top_bar row align-items-center mt-3">
                <div className="col">
                    <div className="pagetitle">
                        Send Push Notification to All Users
                    </div>
                </div>
            </div>

            {/* Notification Form */}
            <div className="card mt-4" style={{ backgroundColor: '#dee6ee' }}>
                <div className="card-body pt-4">
                    {/* Can wrap in <form onSubmit={handleSendNotification}> if preferred */}
                    <div className="row g-3">
                        <div className="col-12">
                            <label htmlFor="notificationTitle" className="form-label">Notification Title</label>
                            <input
                                type="text"
                                className="form-control"
                                id="notificationTitle"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                placeholder="Enter notification title"
                                maxLength={50} // Optional: Add length limit
                                required
                                disabled={loading}
                            />
                        </div>

                        <div className="col-12">
                            <label htmlFor="notificationMessage" className="form-label">Notification Message</label>
                            <textarea
                                className="form-control"
                                id="notificationMessage"
                                rows="5"
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                placeholder="Enter notification message body"
                                maxLength={maxMessageLength}
                                required
                                disabled={loading}
                            ></textarea>
                            <div className="form-text text-end mt-2">
                                {message.length}/{maxMessageLength} characters
                            </div>
                            <div className="progress mt-2" style={{ height: '5px' }}>
                                <div
                                    className="progress-bar"
                                    role="progressbar"
                                    style={{ width: `${(message.length / maxMessageLength) * 100}%` }}
                                    aria-valuenow={message.length}
                                    aria-valuemin="0"
                                    aria-valuemax={maxMessageLength}
                                ></div>
                            </div>
                        </div>

                        <div className="col-12 text-end">
                            {/* Using your custom Button or a standard button */}
                            <Button
                                text={loading ? "Sending..." : "Send Notification"}
                                onClick={handleSendNotification}
                                disabled={loading || !title.trim() || !message.trim()}
                                className="btn btn-primary" // Add Bootstrap classes if needed
                            />
                            {/* Or standard button:
                            <button
                                type="button" // or "submit" if using a <form>
                                className="btn btn-primary"
                                onClick={handleSendNotification}
                                disabled={loading || !title.trim() || !message.trim()}
                            >
                                {loading ? "Sending..." : "Send Notification"}
                            </button> */}
                        </div>
                    </div>
                    {/* End Form */}
                </div>
            </div>
        </>
    );
}